import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { CreateRandomClinicalTrialContext } from '../../mocks/clinicalTrialContext';

export const fetchClinicalTrialContextMock = () => {
  const { data } = CreateRandomClinicalTrialContext();
  return axiosMock.onGet(API_URL.clinicalTrialContext).reply(200, data);
};
